import AuthenticationEndPointPage from './container';

export default AuthenticationEndPointPage;
